module.exports = __webpack_public_path__ + "static/media/nov2024-4.61e31f2b.webp";